import { Card, CardContent, CardHeader, Chip, Stack } from '@mui/material';

import useStyles from './CaseDetailCard.styles';
import type { CaseDetailCardProps } from './CaseDetailCard.types';

export const CaseDetailCard = ({
  title,
  labels,
  children,
  style
}: CaseDetailCardProps) => {
  const { classes } = useStyles();

  return (
    <Card className={classes.caseDetailsCardContainer} style={style}>
      <CardHeader
        className={classes.caseDetailsCardHeader}
        title={
          <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
            {title}
            <Stack direction="row" spacing={1}>
              {labels?.map((label: string) => (
                <Chip key={label} variant="outlined" label={label} />
              ))}
            </Stack>
          </Stack>
        }
      />
      <CardContent className={classes.caseDetailsCardContent}>
        {children}
      </CardContent>
    </Card>
  );
};

export default CaseDetailCard;
